var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187.209,
    height: 160.842,
    viewBox: "0 0 187.209 160.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#c9c9c9;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M118.8,152.51a16.558,16.558,0,0,1-5.688-12.443,18.456,18.456,0,0,1,5.688-13.509q18.487-19.2,23.463-47.637Q126.619,77.5,116.309,67.189T106,40.527q0-17.775,11.021-29.151T144.393,0q17.775,0,28.8,13.865t11.021,41.594q0,56.169-36.261,94.563-7.109,7.821-16.353,7.821A18.248,18.248,0,0,1,118.8,152.51Zm-106,0A16.555,16.555,0,0,1,7.11,140.067,18.453,18.453,0,0,1,12.8,126.558q18.486-19.2,23.463-47.637Q20.619,77.5,10.31,67.189T0,40.527Q0,22.752,11.021,11.376T38.394,0q17.774,0,28.8,13.865T78.21,55.458q0,56.169-36.261,94.563-7.11,7.821-16.353,7.821A18.244,18.244,0,0,1,12.8,152.51Z",
    transform: "translate(185.709 159.342) rotate(180)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.c03b6c5770dbe99d3c9baf0d27589846.svg";
export { ForwardRef as ReactComponent };